module.exports = __webpack_public_path__ + "static/media/platforms-graphic-hero.d919ab81.png";